module.exports = "<div class=\"tabs\">\n  <div class=\"tabs__nav\">\n    <button>Lorem</button>\n    <button>Ipsum</button>\n    <button>Dolor</button>\n  </div>\n  <div class=\"tabs__content\">\n    <div class=\"tab\">\n      Lorem ipsum dolor sit amet\n    </div>\n    <div class=\"tab\">\n      Ipsum dolor sit amet lorem\n    </div>\n    <div class=\"tab\">\n      Dolor sit amet lorem ipsum\n    </div>\n  </div>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader?interpolate!./src/components/tabs/sample.html
// module id = 52
// module chunks = 0